import DiscardSignatureModal from '@/components/digital-signature/DiscardSignatureModal.vue';

let VueComponent;
let component;

function close() {
  if (!component) return;
  const current = component;
  component = null;
  current.show = false;
  current.$nextTick(() => current.$destroy());
}

function open({ documentType, discard }) {
  close();

  component = new VueComponent({
    propsData: {
      show: true,
      documentType,
      discard,
    },
  });

  component.$on('close', close);

  component.$mount();
}

export default function install(Vue) {
  VueComponent = Vue.extend(DiscardSignatureModal);

  Object.defineProperty(Vue.prototype, '$discardSignature', {
    get() {
      return { open, close };
    },
  });
}
